import ContentHeader from './contentHeader/ContentHeader'
import ContentBody from './contentBody/ContentBody'
import PasswordInstructions from './passwordInstructions/PasswordInstructions'
import AuditTab from './audit/AuditTab'
import CommentsGrid from './commentsGrid/CommentsGrid'
import DocumentsGrid from './documentsGrid/DocumentsGrid'
import SponsorDocumentsGrid from './sponsorDocumentsGrid/SponsorDocumentsGrid'
import MapContainer from './mapContainer/MapContainer'
import ReviewUpload from './reviewUpload/ReviewUpload'
import SponsorCommentsGrid from './sponsorCommentsGrid/SponsorCommentsGrid'
import FileGrid from './fileGrid/FileGrid'
import OutlineLabel from './outlineLabel/OutlineLabel'
import CertificationDaysOpenStatus from './certificationDaysOpen/CertificationDaysOpenStatus'
import VeteranAppIdHeader from './certificationDaysOpen/VeteranAppIdHeader'
import AdminAppIdHeader from './certificationDaysOpen/AdminAppIdHeader'

export { ContentHeader, ContentBody, PasswordInstructions, AuditTab, CommentsGrid, DocumentsGrid, MapContainer, ReviewUpload,
    SponsorCommentsGrid, SponsorDocumentsGrid, FileGrid, OutlineLabel, CertificationDaysOpenStatus, VeteranAppIdHeader, AdminAppIdHeader };



// WEBPACK FOOTER //
// ./src/areas/shared/components/index.js